import script from "./ThankYouPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ThankYouPage.vue?vue&type=script&setup=true&lang=js"

import "./ThankYouPage.vue?vue&type=style&index=0&id=547e8cac&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/claims-portal/claims-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-547e8cac"]])

export default __exports__